import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { Toaster } from 'sonner';
import { AuthProvider } from '@/providers/AuthProvider';
import { SecurityProvider } from '@/providers/SecurityProvider';
import './index.css';
import { configureGlobalErrorHandling } from './utils/error';

// Configure global error handling and security monitoring
configureGlobalErrorHandling();

// Initialize security features
document.addEventListener('DOMContentLoaded', () => {
  // Set security headers - allow Supabase connections and external images
  const meta = document.createElement('meta');
  meta.httpEquiv = 'Content-Security-Policy';
  meta.content = "default-src 'self' https://*.supabase.co; script-src 'self' 'unsafe-inline'; style-src 'self' 'unsafe-inline'; img-src 'self' data: https: http:; connect-src 'self' https://*.supabase.co wss://*.supabase.co https://ai.gateway.lovable.dev;";
  document.head.appendChild(meta);
  
  // Add CSRF token
  const csrfToken = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  const csrfMeta = document.createElement('meta');
  csrfMeta.name = 'csrf-token';
  csrfMeta.content = csrfToken;
  document.head.appendChild(csrfMeta);
});

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <SecurityProvider>
        <AuthProvider>
          <App />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </SecurityProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
